export const bootstrap_css_install_vars = function bootstrap_css_install_vars(type) {
  let hue = getComputedStyle(document.documentElement, null).getPropertyValue("--frame-color-hue");
  let tag = getComputedStyle(document.documentElement, null).getPropertyValue("--frame-tag");
  let title = getComputedStyle(document.documentElement, null).getPropertyValue(
    "--html-process-title",
  );
  let adminTitle = getComputedStyle(document.documentElement, null).getPropertyValue(
    "--html-process-admin-title",
  );

  if (hue !== "" && Number(hue) >= 0) {
    let frameColor =
      "--frame-color: hsl(var(--frame-color-hue), var(--frame-color-saturation), var(--frame-color-lightness))";
    let frameColor10L =
      "--frame-color-10l: hsl(var(--frame-color-hue), var(--frame-color-saturation), calc(var(--frame-color-lightness) + 10%))";
    let frameColor50L =
      "--frame-color-50l: hsl(var(--frame-color-hue), var(--frame-color-saturation), calc(var(--frame-color-lightness) + 50%))";
    let frameColor90A =
      "--frame-color-90a: hsla(var(--frame-color-hue), var(--frame-color-saturation), var(--frame-color-lightness), 90%)";
    let frameColor10L90A =
      "--frame-color-10l-90a: hsla(var(--frame-color-hue), var(--frame-color-saturation), calc(var(--frame-color-lightness) + 10%), 90%)";
    let frameColor50L90A =
      "--frame-color-50l-90a: hsla(var(--frame-color-hue), var(--frame-color-saturation), calc(var(--frame-color-lightness) + 50%), 90%)";
    let styleNode = document.createElement("style");
    styleNode.setAttribute("type", "text/css");
    styleNode.setAttribute("id", "install-variables");
    let textNode = document.createTextNode(`:root {
      ${frameColor};
      ${frameColor10L};
      ${frameColor50L};
      ${frameColor90A};
      ${frameColor10L90A};
      ${frameColor50L90A};
    }`);
    styleNode.appendChild(textNode);
    document.head.appendChild(styleNode);
  }

  if (tag) {
    if (type == "oms") document.title = `${title} (${tag.toLocaleUpperCase()})`;
    if (type == "admin") document.title = `${adminTitle} (${tag.toLocaleUpperCase()})`;

    document.body.dataset.frameTag = tag.toLocaleUpperCase();
  } else {
    if (type == "oms") document.title = `${title}`;
    if (type == "admin") document.title = `${adminTitle}`;
  }
};
